import React, { useRef, useState, useCallback } from 'react'
import Slider from '../../../../../ui_reusable/Slider'
import {
  SliderInputHStack,
  SliderContainer,
} from './styles/BuildScenarioRowSlider.styles'
import useBuildScenarioStore, {
  useScenarioDriverValue,
} from '../../../stores/buildScenarioStore'
import IndependentDriverPlotDebug from './IndependentDriverPlotDebug'

// Developer toggle: Set to false to disable IndependentDriverPlotDebug component
const ENABLE_DEBUG_PLOT = true
const BuildScenarioRowSlider = ({ scenarioId, rowData, driverId }) => {
  const containerRef = useRef(null)
  const timeoutRef = useRef(null)
  const [isDebugVisible, setIsDebugVisible] = useState(false)

  // Subscribe to the specific driver value for this scenario
  const driverValueObject = useScenarioDriverValue(scenarioId, driverId)
  const currentValue = driverValueObject.value

  // Store actions
  const setScenarioDriverValue = useBuildScenarioStore(
    (state) => state.setScenarioDriverValue,
  )
  const calculateDriverInputBounds = useBuildScenarioStore(
    (state) => state.calculateDriverInputBounds,
  )
  const { minValue, maxValue, steps } = calculateDriverInputBounds(driverId)

  const handleDriverSliderChange = useCallback(
    (value) => {
      setScenarioDriverValue(scenarioId, driverId, value)

      // Show debug overlay
      setIsDebugVisible(true)

      // Clear existing timeout
      if (timeoutRef.current) {
        clearTimeout(timeoutRef.current)
      }

      // Set new timeout to hide after 3 seconds
      timeoutRef.current = setTimeout(() => {
        setIsDebugVisible(false)
        timeoutRef.current = null
      }, 1000) // Ensure this is exactly 3000ms
    },
    [scenarioId, driverId, setScenarioDriverValue],
  )

  // Cleanup effect
  React.useEffect(() => {
    return () => {
      if (timeoutRef.current) {
        clearTimeout(timeoutRef.current)
      }
    }
  }, [])
  return (
    <SliderContainer ref={containerRef}>
      {ENABLE_DEBUG_PLOT && (
        <IndependentDriverPlotDebug
          hookRef={containerRef}
          scenarioId={scenarioId}
          driverId={driverId}
          isVisible={isDebugVisible}
          id={'slider-debug'}
        />
      )}
      <SliderInputHStack>
        <Slider
          snap={[
            {
              snapStart: driverValueObject.observationValueEnd * 0.99,
              snapEnd: driverValueObject.observationValueEnd * 1.01,
              goTo: driverValueObject.observationValueEnd,
            },
          ]}
          value={currentValue}
          onChange={handleDriverSliderChange}
          min={minValue}
          max={maxValue}
          step={steps}
          trackWidth={3} // Default 1rem (16px)
          data-testid={`slider-${rowData.name}`}
        />
      </SliderInputHStack>
    </SliderContainer>
  )
}

export default BuildScenarioRowSlider
